module.exports = __webpack_public_path__ + "static/media/HS-G-PC-02.f35b0499.jpg";